import { Divider, VStack } from "@gluestack-ui/themed";
import { ReviewFidelityProposalController } from "./controller";
import { ProposalAccordion } from "@repo/core/components/layout/ProposalAccordion";
import { ProposalProductSection } from "@repo/core/components/layout/ProposalProductSection";
import { ProposalLocationSection } from "@repo/core/components/layout/ProposalLocationSection";
import { ProgressBar } from "@repo/core/components/layout/ProgressBar";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";

const ReviewFidelityProposal = () => {
  const {
    handleGoBack,
    handleSubmit,
    handleEditCompleteRegistration,
    handleEditSelectProduct,
    handleEditSelectServicePoint,
    handleClose,
    handleAbandon,
    proposalData,
    selectedServicePoint,
    isLoading,
    formattedData,
    isSaving
  } = ReviewFidelityProposalController();

  return (
    <>
      <PageScaffold
        title="Revisar Proposta"
        onBackPress={handleGoBack}
        showBackButtonOnWeb
        onPressRightIcon={handleClose}
        rightWebLabel="Fechar"
        isLoading={isLoading}
        loadingTitle="Carregando dados da proposta"
        loadingDescription="Aguarde enquanto buscamos as informações..."
        footerContent={
          !isLoading ? (
            <ScaffoldFooter
              primaryText="Efetivar Fidelidade"
              primaryAction="primary"
              primaryOnPress={handleSubmit}
              primaryIsLoading={isSaving}
              primaryIsDisabled={isSaving}
              secondaryText="Abandonar"
              secondaryVariant="outline"
              secondaryAction="darker-secondary"
              secondaryOnPress={handleAbandon}
              secondaryIsDisabled={isSaving}
            />
          ) : undefined
        }
      >
        <VStack w="$full" gap="$6" pb="$4">
          <ProgressBar progress={80} />
          <ProposalAccordion.CompleteRegistration
            title="Dados de Segurança"
            value="securityData"
            isOpen
            birthday={formattedData.birthday}
            gender={formattedData.gender}
            martialStatus={formattedData.martialStatus}
            profession={formattedData.profession}
            name={formattedData.name}
            cpf={formattedData.cpf}
            phone={formattedData.phone}
            onPressEdit={isSaving ? undefined : handleEditCompleteRegistration}
          />
          <Divider />
          <ProposalProductSection
            name={proposalData?.strProdutoDescricao || ""}
            description=""
            cardNumber={proposalData?.strProduto || ""}
            onPressChangeProduct={
              isSaving ? undefined : handleEditSelectProduct
            }
          />
          {/*   <Divider /> */}
          {/*  <ProposalFinancialServicesSection
            name={proposalData?.strServico || ""}
            value={proposalData?.strSubServico || ""}
            onPressChangeFinancialServices={handleEditFinancialServices}
          /> */}
          <Divider />
          <ProposalLocationSection
            name={selectedServicePoint?.descricao || ""}
            region={selectedServicePoint?.ponto || ""}
            onPressChangeLocation={
              isSaving ? undefined : handleEditSelectServicePoint
            }
          />
        </VStack>
      </PageScaffold>
    </>
  );
};

export default ReviewFidelityProposal;
